export default "<h3>Integration Language Settings</h3>\n<app-api-gateway-settings></app-api-gateway-settings>\n"